import { XCircleIcon } from "@heroicons/react/24/outline"
import { useFormContext } from "react-hook-form"

interface SelectedItemsListProps {
  fieldName: string
  label: string
}

export function SelectedItemsList({ fieldName, label }: SelectedItemsListProps) {
  const { watch, setValue } = useFormContext()
  const items = watch(fieldName) ?? []

  const handleRemove = (index: number) => {
    const updated = items.filter((_: any, i: number) => i !== index)
    setValue(fieldName, updated, { shouldDirty: true })
  }

  if (items.length === 0) return null

  return (
    <div className="mt-3">
      <p className="text-xs font-semibold text-gray-600 dark:text-gray-400 mb-2">
        Selected {label} ({items.length})
      </p>
      <div className="flex flex-wrap gap-2">
        {items.map((item: any, index: number) => (
          <div
            key={item.id || index}
            className="inline-flex items-center gap-2 px-3 py-1 bg-blue-100 dark:bg-blue-900 rounded-full text-sm"
          >
            <span className="text-blue-800 dark:text-blue-200">
              {item.name || item.title || item.id}
            </span>
            <button
              type="button"
              onClick={() => handleRemove(index)}
              className="text-red-600 dark:text-red-400 hover:text-red-800 dark:hover:text-red-300"
              title="Remove"
            >
              <XCircleIcon className="h-4 w-4" />
            </button>
          </div>
        ))}
      </div>
    </div>
  )
}
